<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="text-h5">Info details</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-card>
            <v-row justify="center">
              <v-img
                v-if="row.icon"
                class="user-profile"
                :src="row.icon"
                max-width="200"
                max-height="200"
              />
              <v-icon
                v-else
                class="user-profile-placeholder"
                size="100"
              >
                fa-user
              </v-icon>
            </v-row>
            <v-card-title class="subheading font-weight-bold">
              {{ row.login_id }}
            </v-card-title>

            <v-divider />

            <v-list dense>
              <v-list-item
                v-for="header in headers"
                :key="header.id"
              >
                <v-list-item-content>{{ header.text }}</v-list-item-content>
                <v-list-item-content class="align-end">
                  <div v-if="header.value == 'user_type'">
                    {{ formatUserType(row[header.value]) }}
                  </div>
                  <div v-else-if="header.value == 'gender'">
                    {{ formatGender(row[header.value]) }}
                  </div>
                  <div v-else-if="header.value == 'status'">
                    {{ formatStatus(row[header.value]) }}
                  </div>
                  <div v-else>
                    {{ row[header.value] }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'
import moment from 'moment'

export default {
  name: 'ScanRecordUserDetails',
  components: {},
  mixins: [ErrorDisplay],
  props: {
    row: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function () {
    return {
      headers: [
        { text: this.$t('general.name'), value: 'name' },
        { text: this.$t('general.tel'), value: 'tel' },
        { text: this.$t('general.userType'), value: 'user_type' },
        { text: this.$t('general.status'), value: 'status' },
        { text: this.$t('general.gender'), value: 'gender' },
        { text: this.$t('general.joinDate'), value: 'joined_at' }
      ]
    }
  },
  computed: {},
  mounted () {},
  methods: {
    formatUserType (userType) {
      if (userType === 'usr') return this.$t('general.user')
      if (userType === 'adm') return this.$t('general.admin')
      return null
    },
    formatGender (gender) {
      if (gender === 0) return this.$t('general.male')
      if (gender === 1) return this.$t('general.female')
      return null
    },
    formatStatus (status) {
      if (status === 0) return this.$t('general.inactive')
      if (status === 1) return this.$t('general.active')
      if (status === -1) return this.$t('general.banned')
      return null
    },
    formatDate (createdAt) {
      moment.locale(this.convertLocale(this.currentLocale, 'bcp47'))
      if (moment(createdAt).isValid()) return moment(createdAt).format('LLL')
      return null
    }
  }
}
</script>

<style scoped>
.max-width {
  width: 100%;
}
</style>
